import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { GenericType } from "@/types";

export const ChartCard = ({
  icon,
  color,
  label,
  value,
  onClick,
  className,
}: {
  icon: GenericType;
  color: string;
  label: string;
  value: number;
  onClick: () => void;
  className?: string;
}) => {
  const Icons = icon;
  const COLORS: GenericType = {
    "sky-blue": "bg-sky-100 text-sky-600",
    teal: "bg-teal-100 text-teal-600",
    red: "bg-red-100 text-red-600",
    purple: "bg-purple-100 text-purple-600",
    orange: "bg-orange-100 text-orange-600",
    green: "bg-green-100 text-green-600",
    gray: "bg-gray-100 text-gray-600",
    blue: "bg-blue-100 text-blue-600",
  };
  return (
    <Card
      className={cn("px-5 py-5 flex flex-col ", className)}
      onClick={onClick}
    >
      <span
        className={cn(
          "w-[40px] h-[40px] flex items-center justify-center rounded-full ",
          COLORS[color],
        )}
      >
        <Icons size={18} />
      </span>
      <div className="text-xl font-bold pt-4 pb-1">{value}</div>
      <div className="text-slate-500">{label}</div>
    </Card>
  );
};
